import PropTypes from 'prop-types';
import HamHeader from "../../Header/HamburgerHeader";
import cn from "classnames";
import style from "./outOfStock.module.scss";
import { useNavigate } from "react-router-dom";
import CartItems from "./CartSection";
import SearchStock from "./SearchStock";
import { ReactComponent as Reload } from '@assets/images/Fireboard/reload.svg'
import { goToView } from '../../../../../utility/fireboardUtil';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const OutOfStock = (props) => {
  const { selectedTab, OnChangeTab, outOfStockItems, onReloadOutOfStock, selectedItems, setSelectedItems, getConfirmation, currentView } = props;
  const navigate = useNavigate();

  const tabOptions = [
    { key: 'items', label: FLABEL().HEADER_ITEMS },
    { key: 'modifiers', label: FLABEL().HEADER_MODIFIERS }
  ];

  const handleItemsSelection = (isSelected, item) => {
    if (isSelected) {
      setSelectedItems(selectedItems.filter((i) => i?.id !== item?.id));
    } else {
      setSelectedItems((prev) => [...prev, item]);
    }
  }

  const Tabs = () => {
    return (
      <div className={cn('d-flex', style.tabContainers)}>
        {tabOptions.map(({ key, label }) => (
          <div
            key={key}
            role="tab"
            aria-selected={selectedTab === key}
            className={cn(
              'col-6 d-flex justify-content-center align-items-center',
              selectedTab === key && style.selectedTab
            )}
            onClick={() => OnChangeTab(key)}
          >
            {label}
          </div>
        ))}
      </div>
    );
  };

  const OutOfStockSection = () => {
    return (
      <div className="h-100 d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center">
          <div className="fw-500">
            {selectedTab === 'items' ? FLABEL().OOS_OUT_OF_STOCK_ITEMS : FLABEL().OOS_OUT_OF_STOCK_MODIFIERS}
          </div>
          <div
            className={cn(style.reloadButton, 'd-flex align-items-center justify-content-center')}
            onClick={() => onReloadOutOfStock()}
          >
            <Reload />
          </div>
        </div>

        <div className={style.itemsContainer}>
          {outOfStockItems?.map((item, index) => {
            const isSelected = selectedItems?.some((i) => i?.id === item?.id);
            return (
              <div key={index} className={cn(style.outofStockItem, isSelected && style.selectedItem)} onClick={() => handleItemsSelection(isSelected, item)}>
                <div className={style.stockOutSign}>86</div>
                <div className={cn(style.posId, 'text-center')}>{item.posId}</div>
                <div className="text-center pt-1 text-truncate">{item.name}</div>
              </div>
            )
          }
          )}
        </div>

        <div className="d-flex gap-2 pt-2">
          <div className="col-12 px-0 d-flex ">
            <div className="col-6 pl-0 pr-1"><button className={cn(style.Secondarybtn, 'col-12 fw-500')} disabled={selectedItems.length === 0} onClick={() => setSelectedItems([])}>{FLABEL().OOS_CLEAR_ALL}</button></div>
            <div className="col-6 pr-0 pl-2"><button className={cn(style.primaryBtn, 'col-12 fw-500')} disabled={selectedItems.length === 0} onClick={() => getConfirmation(selectedItems)} >{FLABEL().OOS_MARK_IN_STOCK}</button></div>
          </div>
        </div>
      </div>
    );
  };


  return (
    <div className="h-100">
      <HamHeader
        filterElement={Tabs}
        label={FLABEL().HEADER_OUT_OF_STOCK}
        onClickback={() => goToView(currentView, navigate)}
      />

      <div className={cn(style.sectionsContainers, 'd-flex px-0 mx-0 pt-3')}>
        <div className={cn(style.section)}><OutOfStockSection /></div>
        <div className={cn(style.section)}>
          <SearchStock {...props} />
        </div>
        <div className={cn(style.section)}><CartItems {...props} /></div>
      </div>
    </div>

  )
}

OutOfStock.propTypes = {
  selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  OnChangeTab: PropTypes.func.isRequired,
  outOfStockItems: PropTypes.array.isRequired,
  onReloadOutOfStock: PropTypes.func.isRequired,
  selectedItems: PropTypes.array.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
  getConfirmation: PropTypes.func.isRequired,
  currentView: PropTypes.string.isRequired,
};

export default OutOfStock;